const OnBoardWhiteLabelPartyKeys = {
  TITLE: "title",
  PARTY_ID: "partyId",
  PARENT_PARTY_ID: "parentPartyId",
  DECLARATION_1: "declaration1",
  DECLARATION_2: "declaration2",
  DECLARATION_3: "declaration3",
  DECLARATION_4: "declaration4",
  DECLARATION_5: "declaration5",
  DECLARATION_6: "declaration6",
  REQUESTER_NAME: "requesterName",
  SELF_DECLARATION_PART_1: "selfDeclarationPart1",
  SELF_DECLARATION_PART_2: "selfDeclarationPart2",
  SUBMIT_BUTTON: "submitButton",
  DISCARD_BUTTON: "discardButton",
  SUCCESS_MSG: "successMsg",
  ERROR_MSG: "errorMsg",
  CHECK_ALL_DECLARATION_ERROR_MSG: "checkAllDeclarationErrorMsg",
  Validations:{ 
   ERROR_MSG_ALPHA_NUMERIC_SPACE: "validations.errMsgAlphaNumericSpace"
  }
}

export default OnBoardWhiteLabelPartyKeys
